import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LoaderSvg from '../../assets/img/dot-revolve.svg';

function CustomLoader() {
  return (
    <Grid display="flex" alignItems="center" justifyContent="center" height="100vh">
      <Box component="img" src={LoaderSvg} role="progressbar" />
    </Grid>
  );
}

export default CustomLoader;
